import React, { useEffect, useState } from "react";
import {
	Box,
	Typography,
	Select,
	MenuItem,
	InputLabel,
	FormControl,
	Paper,
	TableContainer,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	TablePagination,
	CircularProgress,
	Button,
	Chip,
} from "@mui/material";
import { MdAddCircle } from "react-icons/md";
import { FaCircleMinus } from "react-icons/fa6";
import useAuth from "../../../hooks/useAuth";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

// Mock API URL (replace with your actual endpoint)
const API_ENDPOINT = "/api/transaction-history";

const TransactionHistoryPage = () => {
	const [transactions, setTransactions] = useState([]);
	const [loading, setLoading] = useState(true);
	const [filterType, setFilterType] = useState("All");
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const { auth, accountMode } = useAuth();
	const axiosPrivate = useAxiosPrivate();

	// Fetch data from API
	const fetchTransactions = async () => {
		setLoading(true);
		try {
			const response = await axiosPrivate(`/singleuser/${auth?.id}`);
			console.log(response);
			if (response.status === 200) {
				setTransactions(response?.data?.foundUser);
			}
			// Assuming API returns { transactions: [], total: number }
			// setTotalCount(data.total);
		} catch (error) {
			console.error("Error fetching transaction data:", error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchTransactions();
	}, []);

	const handleFilterChange = (event) => {
		setFilterType(event.target.value);
		setPage(0); // Reset to first page on filter change
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const activeTxnHistoryArray =
		accountMode === "real"
			? transactions?.realAccountTxnHistory
			: transactions?.demoAccountTxnHistory;

	console.log(activeTxnHistoryArray);

	const content = (
		<Box sx={{ mt: "3rem" }}>
			<h2 className=" w-fit text-[1.4rem]   font-bold tracking-wide mx-auto ">
				Transaction history
			</h2>
			<ul>
				{activeTxnHistoryArray && activeTxnHistoryArray.length != 0 ? (
					activeTxnHistoryArray.map((data) => (
						<li
							style={{ wordSpacing: "0.5rem" }}
							className=" w-fit mr-auto  pl-[1rem]">
							{data.txnType === "deposit" ? (
								<MdAddCircle className="text-green-500  inline-block" />
							) : (
								<FaCircleMinus className="text-red-500     inline-block  " />
							)}{" "}
							{data.txnType} {data.walletType} ${data.amount} {""}
							{new Date(data?.date).getFullYear()}-
							{(new Date(data?.date).getMonth() + 1)
								.toString()
								.padStart(2, "0")}
							-{new Date(data?.date).getDate().toString().padStart(2, "0")}{" "}
							{new Date(data?.date).getHours().toString().padStart(2, "0")}:
							{new Date(data?.date).getMinutes().toString().padStart(2, "0")}:
							{new Date(data?.date).getSeconds().toString().padStart(2, "0")}
						</li>
					))
				) : (
					<p className="mx-auto text-center mt-[2rem]">No history data found</p>
				)}
			</ul>
		</Box>
	);

	return content;
};

export default TransactionHistoryPage;
